enum ConfigurationReference {
    ActiveSeason = 'ACTIVE_SEASON',
    SalesCampaign = 'SALES_CAMPAIGN',
    Insurance = 'INSURANCE',
}

export default ConfigurationReference;
